import React, { useState } from 'react';

const ReactiveImage = ({ fileName, altText = "Public folder image" }) => {
  // A simple state to demonstrate reactivity
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      style={{
        // Fill the entire right side.
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <img
        // The leading slash tells React to look in the public folder.
        src={`/${fileName}`}
        alt={altText}
        style={{
          display: 'block',
          // Scale reactively to the available space while always keeping the
          // whole image visible (never cropped): bounded by the pane width and
          // the viewport height, aspect ratio preserved.
          width: 'auto',
          height: 'auto',
          maxWidth: '100%',
          maxHeight: '82vh',
          objectFit: 'contain',
          borderRadius: '8px',
          // A subtle, non-clipping hover response.
          transform: isHovered ? 'scale(1.02)' : 'scale(1)',
          transition: 'transform 0.3s ease-in-out',
          cursor: 'pointer'
        }}
      />
    </div>
  );
};

export default ReactiveImage;